import { MeasurementSystem } from '@app/core/enums/measurement-system.enum';
import { MetricLengthUnit, ImperialLengthUnit } from '@app/shared/units/length/length-unit.enum';

export const measurementSystemLengthUnit_m_ft = {
  [MeasurementSystem.Metric]: MetricLengthUnit.Meter,
  [MeasurementSystem.Imperial]: ImperialLengthUnit.Foot,
};

export const measurementSystemLengthUnit_km_mile = {
  [MeasurementSystem.Metric]: MetricLengthUnit.Kilometer,
  [MeasurementSystem.Imperial]: ImperialLengthUnit.Mile,
};
